module.exports = __webpack_public_path__ + "img/site-seguro.9ff6ee2b.png";